
import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import Nav from "@/components/semantics/Navigation.vue";
import Nav2 from "@/components/semantics/Navigation2.vue";
import TitleHeader from "@/components/base/table/header/LeftLineHeader.vue";
import { mapState } from "vuex";
import { TitleConfig, RouteConfig } from "@/config";
import { State, Getter, Action, Mutation } from "vuex-class";
import { dispatchLogOut } from "@/store/dispatches";
import cookie from "js-cookie";

import {
  deepClone,
  getStorage,
  getParentArea,
  getAreaDepartmentByLastCode,
} from "@/common/utils";
@Component({
  name: "NavHeader",
  components: {
    Nav,
    Nav2,
    TitleHeader,
  },
})
export default class NavHeader extends Vue {
  @Getter("cityId") private cityId: any;
  @Action("account/getAuthernData") private getAuthern: any;
  @Action("addPopularCitiy") private addPopularCitiy: any;
  @Action("getHotCity") private getHotCityData: any;
  @Getter("city") private city: any;
  @Getter("account") private account: any;
  @Getter("phone") private phone: any;
  @Getter("company") private userName: any;
  @Getter("role") private role: any;
  @Mutation("setCity") private setCity: any;
  currentProvince: any = "";
  currentCities: any = [];
  company: any = "";
  is_login = false;
  pcm: any = TitleConfig;
  lightenList: any = RouteConfig.lightenList;
  enHeaderArr: Array<any> = [];
  enArr: Array<any> = [];
  activeEn = 0;
  activeProvince = 0;
  provinceArr: Array<any> = [];
  cityArr: Array<any> = [];
  area_option: Array<any> = this.$root.$data.areaOption;
  hotCityArr: Array<any> = [];
  visible = false;
  provinceId = "";
  first: any = false;
  @Watch("visible", { immediate: true })
  handleVisibleChange(newValue: any, oldValue: any) {
    if (newValue) {
      this.getHotCity();
    }
  }
  async created() {
    this.getData();
    if (cookie.get("accessToken")) {
      this.is_login = true;
    }
    if (this.$route.path == "/pcm/homePage") {
      this.first = true;
    } else {
      this.first = false;
    }
    // this.provinceId = 110000
    this.provinceId = this.city.provinceId;
    this.currentProvince = this.provinceId; //this.provinceId = 120000
    if (this.currentProvince) {
      this.selectProvince({ id: this.provinceId });
    }
  }
  async getData() {
    this.getBasicData();
    // this.getHotCity();
    // this.getCityData();
  }
  async getBasicData() {
    const data = await getStorage("basic");
    if (data) {
      const { nickName } = data;
      this.company = nickName;
    }
  }
  async selectProvince(item: any) {
    this.currentProvince = item.id;

    const tempCity = getAreaDepartmentByLastCode(this.area_option, item.id);
    const { children } = tempCity;
    this.currentCities = children || [];
  }
  async selectCity(item: any) {
    console.log(item, "当前点击的");
    this.visible = false;
    let { id, name, parentId } = item;
    let provinceId = "";
    // if (parent) {
    //   provinceId = parentId;
    // } else {
    //   const provinceItem: any = getParentArea(this.area_option, id);
    //   provinceId = provinceItem ? provinceItem.value : provinceItem;
    // }
    this.setCity({ id, name, parentId, provinceId: parentId });
    // this.addPopularCitiy({ id, name });
    // location.reload();
  }
  clickEnOption(index: any) {
    this.activeEn = index;
    switch (index) {
      case 0:
        this.getHotCity();
        break;
      default:
        this.getEnCity();
        break;
    }
  }
  async getHotCity() {
    const res = await this.getHotCityData();
    if (res) {
      this.cityArr = res
        .map(({ value: { code: value, name: label } }: any) => {
          const parent: any = getParentArea(this.area_option, value);
          return {
            value,
            label,
            parent,
          };
        })
        .filter((province: any) => {
          const directCityLabelList = [
            "天津市辖区",
            "北京市辖区",
            "重庆市辖区",
            "上海市辖区",
            "中央",
          ];
          return !directCityLabelList.includes(province.label);
        });
    }
  }
  getEnCity() {
    const cityData = deepClone(this.area_option);
    const en = this.enArr[this.activeEn - 1];
    const provinceArr = cityData.filter(({ initials }: any) => {
      return initials === en;
    });

    this.provinceArr = provinceArr;
  }
  toUser() {
    /*if (this.role) {
			this.$router.push({ path: `/${this.role}/declarePage` });
		}*/
    // console.log(this.role, 7777);
    this.$router.push({ path: `/unit/ApplyNo` });
  }
  toLogin() {
    const options: any = this.$route.query;
    this.$router.push({
      name: "Login",
      params: {
        beforePath: this.$route.path,
        beforeOption: options,
      },
    });
  }
  toRegist() {
    this.$router.push({ path: "/regist" });
  }
  logOut() {
    const options: any = this.$route.query;
    this.$router.push({
      name: "Login",
      params: {
        beforePath: this.$route.path,
        beforeOption: options,
      },
    });
    dispatchLogOut();
  }
  handleClick() {}
  @Watch("role")
  handleRoleChange(newValue: any, oldValue: any) {}

  @Watch(`$route`)
  handleRoutechange({ path }: any, from: any) {
    if (path === "/pcm/homePage") {
      this.first = true;
    } else {
      this.first = false;
    }
  }
}
